import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';


@Injectable()
export class UserFriendlyMsgs {
    errorHandler(error: HttpErrorResponse) {
        
        switch (error.status) {
            case 404:
                return Observable.throw('Not Found');
            case 500:
                return Observable.throw('Internal Server Error');
            case 400:
                return Observable.throw('Bad Request');
            case 403:
                return Observable.throw('Forbidden');
            case 401:
                return Observable.throw('Unauthorized');
            default:
                return Observable.throw('Sorry APIs are down, Please login back again in couple of minutes. Thank you!');
        }
    }

}





// WEBPACK FOOTER //
// ./src/app/app.user-msgs.ts